import React from 'react'
import EditableCell from './EditableCell'
import { Button } from 'antd';

class FundRow extends React.Component {
    onDelEvent() {
      this.props.onDelEvent(this.props.fund);
  
    }

    render() {
      const onTableUpdate = this.props.onTableUpdate
      return (
        <tr className="" >
          <EditableCell 
            onTableUpdate={onTableUpdate}
            cellData={{
            "type": "description",
            value: this.props.fund.description,
            rowid: this.props.fund.fundId
          }}/>
          <EditableCell  
          onTableUpdate={onTableUpdate}
          cellData={{
            type: "sortOrder",
            value: this.props.fund.sortOrder,
            rowid: this.props.fund.fundId
          }}/>
          <EditableCell onTableUpdate={onTableUpdate}
             cellData={{
            type: "active",
            value: this.props.fund.active,
            rowid: this.props.fund.fundId
          }}/>
          <td className="del-cell">
          <Button type="danger" onClick={this.onDelEvent.bind(this)} icon="delete">Delete</Button>

            {/* <input type="button" onClick={this.onDelEvent.bind(this)} 
            value="X" className="del-btn"/> */}
          </td>
        </tr>
      );
  
    }
  
  }

  export default FundRow